import defaultState from '@/store/state';

const mutations = {
	SIDEBAR_UPDATED(state, sidebar) {
		state.sidebar = sidebar;
	},
	TOKEN(state, token) {
		state.token = token;
	},
	ME(state, user) {
		state.user = user;
	},
	LOGOUT(state) {
		console.log('logout');
		localStorage.clear();
		Object.assign(state, defaultState);
	},
	PAYMENT_TYPES(state, data) {
		state.paymentTypes = data;
	},
	SET_COUNTRIES(state, data) {
		state.countries = data;
	},
	SET_CITIES(state, data) {
		state.cities = data;
	},
	POS_SETTINGS(state, data) {
		state.posSettings = data;
	},
	CAMPAIGN_POSITIONS(state, data) {
		state.campaignPositions = data;
	},
	CAMPAIGN_TYPES(state, data) {
		state.campaignTypes = data;
	},
	CAMPAIGN_REDIRECTION_TYPES(state, data) {
		state.campaignRedirectTypes = data;
	},
	FILTER_TYPES(state, data) {
		state.filterTypes = data;
	},
	PRICE_RANGES(state, data) {
		state.priceRanges = data;
	},
	CONTACT_TYPES(state, data) {
		state.contactTypes = data;
	},
	SET_FCM_TOKEN(state, data) {
		state.fcmToken = data;
	},
	SET_BUSINESS_OFFLINE(state, id) {
		const restaurantIndex = state.user.restaurants.findIndex(({ restaurantID }) => restaurantID === id);
		state.user.restaurants[restaurantIndex].status = 90;
	},
	SET_BUSINESS_ONLINE(state, id) {
		const restaurantIndex = state.user.restaurants.findIndex(({ restaurantID }) => restaurantID === id);
		state.user.restaurants[restaurantIndex].status = 1;
	},
	UPDATE_SELECTED_BUSINESSES(state, data) {
		state.selectedRestaurants = data;
	},
	SET_SELECTED_BUSINESS_ID(state, data) {
		state.selectedBusinessId = data;
	},
	SET_LOADING_ORDER_ID(state, id) {
		state.loadingOrderId = id;
	},
	SET_RESTAURANT_EXTRA_DELIVERY_TIME(state, payload) {
		state.user.restaurants[payload.index].extraDeliveryTime = payload;
	},
	SET_BUSINESS_CLOSING_REASONS(state, data) {
		state.closingReasonsGlobal = data;
	},
	SET_BUSINESS_REJECT_REASONS(state, data) {
		state.rejectReasonsGlobal = data;
	},
	SET_BUSINESS_CLOSING_TIME(state, payload) {
		const restaurantIndex = state.user.restaurants.findIndex(
			({ restaurantID }) => restaurantID === payload.businessId
		);
		state.user.restaurants[restaurantIndex].closingTime = payload;
	},
};

export default mutations;
